@if (upperValue !== null && lowerValue !== null) {
  <mat-slider id="double_slider_for_filter"
              [max]="max"
              [min]="min"
              [step]="step"
              [discrete]="displayLabels"
              [displayWith]="displayWith"
              [class.label-down]="labelsOverlap()">
    <input
      matSliderStartThumb
      [value]="lowerValue"
      [aria-label]="labelsLowerAndUpperValue.labelLowerValue"
      (input)="onLowerInput($event)"
      (valueChange)="onLowerValueChange($event)">
    <input
      matSliderEndThumb
      [value]="upperValue"
      [aria-label]="labelsLowerAndUpperValue.labelUpperValue"
      (input)="onUpperInput($event)"
      (valueChange)="onUpperValueChange($event)">
  </mat-slider>
} @else {
  <mat-slider [max]="max"
              [min]="min"
              [step]="step"
              [discrete]="displayLabels"
              [displayWith]="displayWith">
    <input matSliderThumb [value]="value" [aria-label]="label" (input)="onInput($event)" (valueChange)="onValueChange($event)">
  </mat-slider>
}
